module.exports = __webpack_public_path__ + "img/mainPicture.d50e8e0e.png";